export const ADMIN_GET_USERS = 'ADMIN_GET_USERS'
export const ADMIN_UPDATE_USER = 'ADMIN_UPDATE_USER'
export const ADMIN_DELETE_USER = 'ADMIN_DELETE_USER'
